import VoucherPDF from 'src/PDF/VoucherPDF'

const BankReceiptVoucherPDF = (pdfData) => {
  const voucherDetails = Array.isArray(pdfData?.voucher_detail) ? pdfData.voucher_detail : []
  const uniqueEmployees = [
    ...new Set(
      voucherDetails
        .map(
          (item) =>
            item?.employee?.full_name ||
            item?.employee?.name ||
            `${item?.employee?.first_name || ''} ${item?.employee?.last_name || ''}`.trim(),
        )
        .filter(Boolean),
    ),
  ]
  const uniqueParties = [
    ...new Set(
      voucherDetails.map((item) => item?.party?.party_name || item?.party?.name).filter(Boolean),
    ),
  ]

  return VoucherPDF(pdfData, {
    title: 'Bank Receipt Voucher',
    typeLabel: 'Bank Receipt Voucher',
    referenceLabel: 'Received From:',
    showEmployeeColumn: uniqueEmployees.length > 1,
    showPartyColumn: uniqueParties.length > 1,
    showSelectionSummary: true,
    showSingleSelectionSummaryOnly: true,
    headerLayout: 'jv_payment',
    sideBySideBankSelectionDetails: true,
  })
}

export default BankReceiptVoucherPDF
